<template>
  <b-card>
    <div id="personal-profile-tab-id">
      <div class="custom-tab">
        <b-tabs card>
          <b-tab
            v-if="canEditCms"
            @click.prevent="setDetailCurrentTab('#profile_memberships', 'personal-profile-tab-id')"
            :active="getDetailActiveTab === 'profile_memberships'"  
          >
            <template #title>
              <i class="fa fa-lock" v-b-tooltip.hover title="Admin, Staff only" aria-hidden="true"></i>
              <span>Program Memberships</span>
            </template>
            <program-memberships :memberships="personData.memberships" />
          </b-tab>
          <b-tab
            v-if="canEditCms || logedInUser"
            @click.prevent="setDetailCurrentTab('#program_visits', 'personal-profile-tab-id')"
            :active="getDetailActiveTab === 'program_visits'"
          >
            <template #title>
              <i v-if="canEditCms" class="fa fa-lock" v-b-tooltip.hover title="Admin, Staff, Self only" aria-hidden="true"></i>
              <span>Program Visits</span>
            </template>
            <div v-if="canEditCms" class="d-flex justify-content-end mb-2">
              <a :href="fetchLegacyUrl(`/people/${$route.params.id}?isEdit=true#tab-members`)" target="_blank">
                <b-btn variant="primary" size="sm">Add Visit</b-btn>
              </a>
            </div>
            <person-program-visit :visits="personData.visits" />
          </b-tab>
          <b-tab
            v-if="canEditCms || logedInUser"
            @click.prevent="setDetailCurrentTab('#registrations', 'personal-profile-tab-id')"
            :active="getDetailActiveTab === 'registrations'"
            >
            <template #title>
              <i v-if="canEditCms" class="fa fa-lock" v-b-tooltip.hover title="Admin, Staff, Self only" aria-hidden="true"></i>
              <span>Registrations</span>
            </template>
            <person-registrations :registrations="personData.registrations" />
          </b-tab>
          <b-tab
            title='Talks'
            @click.prevent="setDetailCurrentTab('#talks', 'personal-profile-tab-id')"
            :active="getDetailActiveTab === 'talks'"
          >
            <talks-tab :workshops="personData.workshops"></talks-tab>
          </b-tab>
          <b-tab
            v-if="canEditCms"
            @click.prevent="setDetailCurrentTab('#notes_passport', 'personal-profile-tab-id')"
            :active="getDetailActiveTab === 'notes_passport'"
          >
            <template #title>
              <i class="fa fa-lock" v-b-tooltip.hover title="Admin, Staff only" aria-hidden="true"></i>
              <span>Notes/Passport</span>
            </template>
            <person-information :formData="formNotesInfo" />
          </b-tab>
          <b-tab
            title="Committees"
            @click.prevent="setDetailCurrentTab('#people_committees', 'personal-profile-tab-id')"
            :active="getDetailActiveTab === 'people_committees'"
            v-if="personData.committees.current_or_future.length !== 0 || personData.committees.past.length !== 0"
          >
            <committees-tab :committees="personData.committees" />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </b-card>
</template>

<script>
import PersonProgramVisit from "@/components/CommonPages/ProfileSection/PersonProgramVisit.vue"
import ProgramMemberships from "@/components/AboutUs/Directories/MemberDirectory/ProfileTabs/ProgramMemberships.vue"
import PersonRegistrations from "@/components/CommonPages/ProfileSection/PersonRegistrationDetail.vue"
import PersonInformation from "@/components/CommonPages/ProfileSection/PersonInformation.vue"
import TalksTab from "@/components/AboutUs/Directories/MemberDirectory/ProfileTabs/TalksTab.vue"
import CommitteesTab from "@/components/AboutUs/Directories/MemberDirectory/ProfileTabs/CommitteesTab.vue"
import mixin from "@/utils/mixin.js"
import { mapGetters } from "vuex"

export default {
	name: "PersonalTabs",
	components: {
		PersonProgramVisit,
		ProgramMemberships,
		PersonRegistrations,
		TalksTab,
		PersonInformation,
		CommitteesTab,
	},
	mixins: [mixin],
	props: ["personData"],
	data() {
		return {
			tabs: [
				"#scheduled_visits",
				"#profile_memberships",
				"#program_visits",
				"#registrations",
				"#talks",
				"#notes_passport",
				"#profile_lists",
			],
		}
	},
	mounted() {
		if (this.tabs.indexOf(this.$route.hash) !== -1) {
			const hashPath = this.$route.hash
			this.setDetailCurrentTab(hashPath.substring(1), "personal-profile-tab-id")
		}
	},
	computed: {
		...mapGetters(["getDetailActiveTab", "authUser", "canEditCms"]),
		logedInUser() {
			return Number.parseInt(this.authUser?.person_id) === Number.parseInt(this.$route.params.id)
		},
		formNotesInfo() {
			return [
				{
					label: "Notes",
					value: this.personData.notes,
					isHtml: true,
				},
				{
					label: "Passport Number",
					value: this.personData.passport_number,
				},
				{
					label: "Issuing Country",
					value: this.personData.passport_issued_country,
				},
				{
					label: "Issuing at",
					value: this.personData.passport_issued_at,
				},
				{
					label: "Expiry Date",
					value: this.personData.passport_expiry_date,
				},
			]
		},
	},
}
</script>

<style scoped>
.card > .card-body {
  padding: 0;
}
</style>
